import { FC } from 'react';
import { Search } from 'lucide-react';
import { RealEstateDto } from 'api/real-estate';
import { BiensTable } from './BiensTable';

interface BiensListProps {
  biens: RealEstateDto[];
  totalCount: number;
  loading: boolean;
  page: number;
  pageSize: number;
  setPage: (page: number) => void;
  search: string;
  setSearch: (value: string) => void;
  onSelectBien: (bien: RealEstateDto) => void;
  /** Fonction de traduction (labels REAL_ESTATE.*) */
  t: (key: string) => string;
}

/**
 * Sous-onglet "Biens" : recherche serveur parmi TOUS les biens du client,
 * liste paginée serveur au design du tunnel de souscription (BiensTable).
 */
export const BiensList: FC<BiensListProps> = ({
  biens,
  totalCount,
  loading,
  page,
  pageSize,
  setPage,
  search,
  setSearch,
  onSelectBien,
  t
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
      {/* Recherche (serveur) */}
      <div className="p-4 flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-52 sm:max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Rechercher un bien par nom ou adresse…"
            className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
          />
        </div>
        {search && (
          <span className="text-xs text-gray-500">
            {totalCount} résultat{totalCount > 1 ? 's' : ''}
          </span>
        )}
      </div>

      {!loading && biens.length === 0 ? (
        <div className="p-8 text-center">
          <p className="text-sm text-gray-500">Aucun bien ne correspond à la recherche.</p>
        </div>
      ) : (
        <BiensTable
          biens={biens}
          isLoading={loading}
          onSelectBien={onSelectBien}
          t={t}
          pageSize={pageSize}
          currentPage={page}
          totalItems={totalCount}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};
